import React from "react";
import footer from "../../Asset/footer/footer.jpg";
import playstore from "../../Asset/footer/playstore.png";
import logobig from "../../Asset/navbar/logobig.png";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";
import { BiLogoInstagramAlt } from "react-icons/bi";
import { FaYoutube } from "react-icons/fa6";
import { FaSquareXTwitter } from "react-icons/fa6";
import { RiInstagramFill } from "react-icons/ri";
import { AiFillInstagram } from "react-icons/ai";

const Footer = () => {
  const Navigate = useNavigate();

  const openWhatsApp = () => {
    const phoneNumber = "917411672999";
    const message = encodeURIComponent(
      "Hello! I'm reaching out via your website."
    );
    const isMobile = /iPhone|Android|iPad|iPod/i.test(navigator.userAgent);

    const whatsappURL = isMobile
      ? `https://wa.me/${phoneNumber}?text=${message}`
      : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

    window.open(whatsappURL, "_blank");
  };
  return (
    <>
      <div className="min-h-screen flex flex-col justify-between bg-Background1 relative z-10">
        <div className="absolute -top-[100px]   w-full flex flex-col justify-center items-center ">
          <div className=" w-11/12  lg:w-3/4 xl:w-[75%] 2xl:w-[71%]  bg-white p-4 lg:p-8 xl:p-8 2xl:p-12 grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-2 lg:gap-5  2xl:gap-10 rounded-4xl shadow-lg">
            <div className="text-2xl md:text-3xl lg:text-3xl xl:text-4xl  2xl:text-5xl font-bold text-textColor">
              Experience our best app
            </div>
            <div className="flex flex-wrap text-base md:text-xl lg:text-base xl:text-lg 2xl:text-2xl">
              Manage Your Cart easily reduce your add quantity of an item Easily
              add address and delivery method
            </div>
            <div className="p-2 flex gap-4 items-center justify-center md:justify-end">
              <img
                src={playstore}
                className="w-2/3 md:w-[20%] lg:w-11/12 xl:w-2/3 object-cover"
                alt=""
              />
            </div>
          </div>

          <div className="  sm:w-4/5 w-11/12 px-2  grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-20 mt-6 md:mt-14 xl:mt-48 ">
            <div className="flex flex-col w-full">
              <img src={logobig} className="w-1/2 md:w-2/3" alt="" />
              <p className="mt-6 px-4 text-textColor text-base lg:text-lg">
                Provide wholesome, organic, and nutrient-packed food, ensuring
                top quality and a commitment to sustainability
              </p>
              <div className="mt-3 lg:mt-8  px-0 sm:px-6 flex lg:gap-8 gap-6 md:gap-5 items-center ">
                <a
                  href="https://www.facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook className="cursor-pointer text-4xl md:text-2xl  lg:text-4xl " />
                </a>
                <a
                  href="https://www.instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AiFillInstagram className="cursor-pointer text-[40px] md:text-2x  lg:text-[38px]" />
                </a>
                <a
                  href="https://x.com/login"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaSquareXTwitter className="cursor-pointer text-[34px] md:text-2xl  lg:text-[34px]" />
                </a>
                <a
                  href="https://www.youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube className="cursor-pointer text-4xl md:text-2xl  lg:text-4xl " />
                </a>
              </div>
            </div>

            <div className="flex flex-col mt-3 md:mt-0">
              <span className="text-xl xl:text-3xl font-bold text-textColor">
                Company Info
              </span>
              <div className="mt-0 sm:mt-3 md:mt-10 lg:mt-8 xl:mt-16 flex flex-col gap-0 lg:gap-4 px-2">
                <span
                  className="text-base sm:text-lg  md:text-base lg:text-lg 2xl:text-xl  text-textColor cursor-pointer hover:text-gray-400"
                  onClick={() => {
                    Navigate("/aboutus");
                  }}
                >
                  About Us
                </span>
                <span
                  className="text-base sm:text-lg 2xl:text-xl text-textColor cursor-pointer hover:text-gray-400"
                  onClick={() => {
                    Navigate("/privacy");
                  }}
                >
                  Privacy Policy
                </span>
                <span
                  className="text-base sm:text-lg 2xl:text-xl text-textColor cursor-pointer hover:text-gray-400"
                  onClick={() => {
                    Navigate("/termandcondion");
                  }}
                >
                  Terms & Condtions
                </span>
              </div>
            </div>
            <div className="flex flex-col mt-3 md:mt-0">
              <span className="text-xl xl:text-2xl font-bold text-textColor">
                Contact Us
              </span>

              <div className="mt-0 sm:mt-3 lg:mt-8 xl:mt-12 flex flex-col gap-0 md:gap-4 lg:gap-6 px-2">
                <a
  href="mailto:sehatfulofficial@gmail.com"
  className="text-base lg:text-lg 2xl:text-xl text-textColor flex gap-2 items-center cursor-pointer"
>
  <MdEmail />
  <span>sehatfulofficial@gmail.com</span>
</a>
                <a
  href="tel:+917411672999"
  className="text-base lg:text-lg 2xl:text-xl text-textColor flex gap-2 items-center cursor-pointer"
>
  <FaPhoneAlt />
  <span>+91 7411672999</span>
</a>
                <div
                  className="text-base lg:text-lg 2xl:text-xl text-textColor flex gap-2 items-center cursor-pointer"
                  onClick={openWhatsApp}
                >
                  <IoLogoWhatsapp />
                  <span>+ 91 7411672999</span>
                </div>
                <div className="text-base lg:text-lg 2xl:text-xl text-textColor flex gap-2 ">
                  <FaMapMarkerAlt className="text-4xl" />
                  <span>
                    Site Number 27, Next to Sobha Sentosa , Balagere Village,
                    Kundalahalli, Bangalore North, Bangalore- 560037, Karnataka
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="flex md:hidden bg-black/50 w-full mt-3 items-center justify-center py-1">
            <span className="text-white pl-4 text-sm font-semibold">
              Copyright © 2025 Sehatful. All rights reserved
            </span>
          </div>
        </div>
        <div className="relative md:absolute bottom-0 hidden md:flex bg-black/50 w-full p-4">
          <span className="text-white pl-4 font-semibold">
            Copyright © 2025 Sehatful. All rights reserved
          </span>
        </div>
        <div className="w-full hidden md:flex">
          <img src={footer} className="w-full h-auto object-cover" alt="img" />
        </div>
      </div>
    </>
  );
};

export default Footer;
